query GetApiKey($id: ID!) {
  apiKey(id: $id) {
    id
    insertedAt
    updatedAt
    name
    notes
    token
    account {
      id
      name
    }
  }
}
